import { render, staticRenderFns } from "./areatype.vue?vue&type=template&id=8da17b8e&scoped=true&"
import script from "./areatype.vue?vue&type=script&lang=js&"
export * from "./areatype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da17b8e",
  null
  
)

export default component.exports